import { render, staticRenderFns } from "./OtherResultReports.vue?vue&type=template&id=2de5623f&scoped=true&"
import script from "./OtherResultReports.vue?vue&type=script&lang=js&"
export * from "./OtherResultReports.vue?vue&type=script&lang=js&"
import style0 from "./OtherResultReports.vue?vue&type=style&index=0&id=2de5623f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de5623f",
  null
  
)

export default component.exports